/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_New_Resume_CtaInputs */

const en_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Resume`)
};

const de_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf erstellen`)
};

const fr_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un CV`)
};

const es_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear currículum`)
};

const it_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Curriculum Vitae`)
};

const nl_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak CV`)
};

const pl_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stwórz CV`)
};

const fi_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ansiotodistus`)
};

const da_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret CV`)
};

const sv_dashboard_action_new_resume_cta = /** @type {(inputs: Dashboard_Action_New_Resume_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa CV`)
};

/**
* | output |
* | --- |
* | "Create Resume" |
*
* @param {Dashboard_Action_New_Resume_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_new_resume_cta = /** @type {((inputs?: Dashboard_Action_New_Resume_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_New_Resume_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_new_resume_cta(inputs)
	if (locale === "fr") return fr_dashboard_action_new_resume_cta(inputs)
	if (locale === "es") return es_dashboard_action_new_resume_cta(inputs)
	if (locale === "it") return it_dashboard_action_new_resume_cta(inputs)
	if (locale === "nl") return nl_dashboard_action_new_resume_cta(inputs)
	if (locale === "pl") return pl_dashboard_action_new_resume_cta(inputs)
	if (locale === "fi") return fi_dashboard_action_new_resume_cta(inputs)
	if (locale === "da") return da_dashboard_action_new_resume_cta(inputs)
	if (locale === "sv") return sv_dashboard_action_new_resume_cta(inputs)
	return en_dashboard_action_new_resume_cta(inputs)
});